import { Component, OnInit } from '@angular/core';
import { AbstractWidgetComponent } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';

@Component({
  selector: 'app-visitor-registration-summary',
  templateUrl: './visitor-registration-summary.component.html',
  styleUrls: ['./visitor-registration-summary.component.scss']
})
export class VisitorRegistrationSummaryComponent extends AbstractWidgetComponent implements OnInit {

  gatekeeperMandatory: boolean;
  isUsingSmartphone: boolean;
  numberPlate: string;
  company: string;
  name: string;
  firstname: string;
  informationTexts: Array<string>;
  showHintForGrandAreaAccessByCar = false;
  accessByCarHintDictionaryKey = 'tmc-visit.widgets.registration-terminal.visitor-registration-summary.hint.access-by-car';

  constructor(
    public translationService: TranslationService
  ) {
    super();
  }

  ngOnInit(): void {
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
    this.gatekeeperMandatory = this.dashboardContext.getContextValue('gatekeeperMandatory');
    this.isUsingSmartphone = this.dashboardContext.getContextValue('driverCommunication') === 'OWN';
    this.numberPlate = this.dashboardContext.getContextValue('numberPlate');
    this.company = this.dashboardContext.getContextValue('company');
    this.name = this.dashboardContext.getContextValue('lastname');
    this.firstname = this.dashboardContext.getContextValue('firstname');
    this.informationTexts = this.dashboardContext.getContextValue('informationTexts');
    this.showHintForGrandAreaAccessByCar = this.translationService.translationExists(this.accessByCarHintDictionaryKey, this.translationService.language);
  }

  public hasSummaryHints() : boolean {
    return this.translationService.translationExists('tmc-yard.widgets.registration-terminal.visitor-registration-summary.hints', this.translationService.language);
  }
}
